// import utils from '@/public/utils'
import sha1 from './sha1';
// userId: number
// appVersion: string
/** 生成L位随机字符串 */
function nonceStr(L) {
    let s = '';
    let randomchar = function () {
        let n = Math.floor(Math.random() * 62);
        if (n < 10)
            return n; // 1-10
        if (n < 36)
            return String.fromCharCode(n + 55); // A-Z
        return String.fromCharCode(n + 61); // a-z
    };
    while (s.length < L)
        s += randomchar();
    return s;
}
/* 生成时间戳 */
function timestampStr() {
    const times = '' + new Date().getTime() / 1000;
    return parseInt(times);
}
/* 生成授权码 */
function signatureStr(timestamp, nonce) {
    let tempArr = [];
    let token = 'MTliMTBiZGY0NTg0YmI3MjI4N2M1Zjg3Y2M1ZWI3Nzc=';
    let res = '';
    tempArr.push(timestamp);
    tempArr.push(nonce);
    tempArr.push(token);
    res = tempArr.join('');
    return sha1(res);
}
export const createCommon = () => {
    let timestamp = timestampStr();
    let nonce = nonceStr(10);
    let signature = signatureStr(timestamp, nonce);
    return {
        timestamp,
        nonce,
        signature,
        h5site: true
    };
};
